export const generateSecretChatId = chatId => `secret-${chatId}`;
